import React from 'react';
import { Box } from '@mui/material';
import VerticalLoadingScreen from './VerticalLoadingScreen';
import { LOADING_IMAGES, LOADING_MESSAGES } from './utils/flightLoading.data';

/**
 * Flight vertical loader — booking, SSR, My Trips, and flight search.
 * @param {string} [_message] Kept for backward compatibility at call sites.
 */
const FlightLoader = ({ message: _message, active = true }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '400px',
        background: 'transparent',
      }}
    >
      <VerticalLoadingScreen
        active={active}
        images={LOADING_IMAGES}
        messages={LOADING_MESSAGES}
      />
    </Box>
  );
};

export default FlightLoader;
